import React, { useState } from 'react';
import cn from 'classnames';
import './OpportunityPlannerAllPromoters.scss';
import { getPrettyPriceDisplay } from '../../../Helpers/formatting';
import Loader from '../../Loader/Loader';
import commaNumber from 'comma-number';

const OpportunityPlannerAllPromoters = props => {
  const { closePlanner, isFetchingFirstPage, results } = props;

  const [isUpdatingPlan, setIsUpdatingPlan] = useState(false);

  const columns = [
    {
      display: 'Num Promoters',
      getValue: result => result.num_promoters || 0
    },
    {
      display: 'Total Volume Driven',
      getValue: result => (result.total_volume_driven ? `${getPrettyPriceDisplay(result.total_volume_driven, { precision: 2 })}` : '$0.00')
    },
    {
      display: 'Total Clicks Driven',
      getValue: result => (result.total_clicks_driven ? `${commaNumber(result.total_clicks_driven)}` : 0)
    },
    {
      display: 'Total Plan Budget',
      getValue: result => (result.total_cost ? `${getPrettyPriceDisplay(result.total_cost)}` : '$0.00')
    }
  ];

  const getLoadingRow = idx => (
    <div key={idx} className={'row loading'}>
      {columns.map((c, idx) => {
        return (
          <div key={idx} className='cell'>
            <Loader size={40} />
          </div>
        );
      })}
    </div>
  );

  const canUpdatePlan = !isFetchingFirstPage && !isUpdatingPlan && results.length === 1 && results[0].num_promoters > 0;

  const createPlanForCohort = async () => {
    if (!canUpdatePlan) return;
    setIsUpdatingPlan(true);
    const result = await props.addPromoterCohortToPlan();
    setIsUpdatingPlan(false);

    if (result.success) {
      window.ALERT.success('Plan updated successfully!');
      closePlanner();
    }
  };

  return (
    <div className='opportunity-planner-all-promoters'>
      <div className={'results-header'}>
        {columns.map(column => {
          const { display } = column;

          return (
            <div key={display} className={'header-cell'}>
              <div className={'display'}>{display}</div>
            </div>
          );
        })}
      </div>
      <div className='results-container'>
        {isFetchingFirstPage && !results.length
          ? getLoadingRow()
          : results.map((result, index) => (
              <div key={index} className={cn('row')}>
                {columns.map(column => {
                  const { display, getValue } = column;
                  const value = getValue(result);
                  return (
                    <div key={display} className={'cell'}>
                      <div className={'display'}>{value}</div>
                    </div>
                  );
                })}
              </div>
            ))}
      </div>
      <div className='plan-action-container'>
        <div className={cn('create-plan-btn', { disabled: !canUpdatePlan })} onClick={createPlanForCohort}>
          Add Creators to Plan
        </div>
      </div>
    </div>
  );
};

export default OpportunityPlannerAllPromoters;
